import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"

import { PagePanel } from "@repo/ui/components/ui/page-panel"
import { SystemConfigList } from "~/modules/system-config/components/system-config-list"

export const Route = createFileRoute(
  "/_protected-layout/_os-layout/_admin-layout/system-config",
)({
  component: RouteComponent,
  beforeLoad: async ({ location }) => {
    // Redirect to the users route if this naked route is accessed directly
    if (location.pathname === "/system-config") {
      throw redirect({ to: "./users", from: "/system-config" })
    }
  },
})

function RouteComponent() {
  return (
    <PagePanel title="System Config">
      <div className="flex h-full flex-col gap-3 md:flex-row">
        <aside className="h-full md:w-1/3 lg:w-1/4">
          <SystemConfigList />
        </aside>
        <div className="h-full flex-1">
          <Outlet />
        </div>
      </div>
    </PagePanel>
  )
}
